'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechprofile', {
        url: '/speechprofile',
        template: '<speechprofile></speechprofile>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechprofile/speechprofile.routes.js